import Invoices from "@/components/Invoices";
import Loading from "@/components/Loading";
import SubscriberDetails from "@/components/SubscriberDetails";
import SubscriptionOffer from "@/components/SubscriptionOffer";
import useUser from "@/lib/queries/user/useUser";
import { useStytchSession } from "@stytch/react";
import { useTranslation } from "react-i18next";
function Subscription() {
  const { t } = useTranslation(["settings", "common"]);
  const stytchSession = useStytchSession();
  const { data: user, isLoading: isUserLoading } = useUser({
    enabled: stytchSession.session !== null,
  });

  return (
    <div className="flex flex-col flex-grow px-6 pt-6 overflow-hidden overflow-y-scroll bg-background">
      <h1 className="font-semibold text-main-title">
        {t("subscription.title")}
      </h1>
      <p className="mb-6 text-main-subtitle text-muted-foreground">
        {t("subscription.description")}
      </p>
      <section className="flex flex-row justify-start w-full gap-4">
        {isUserLoading ? (
          <Loading />
        ) : (
          <>
            {!user?.subscribed && <SubscriberDetails />}
            {user?.subscribed && <SubscriptionOffer />}
          </>
        )}
      </section>
      <Invoices />
    </div>
  );
}

export default Subscription;
